import { DatepickerModule, BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NgxCurrencyModule } from "ngx-currency";
import { PickerModule } from "@ctrl/ngx-emoji-mart";
import { NgxMaskModule } from "ngx-mask";
import { ChartsModule } from "ng2-charts";
import { NgxSelectModule } from "ngx-select-ex";
import { SharedModule } from "../../shared/shared.module";
import { Ng2TableModule } from "ng2-table/ng2-table";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { AgmCoreModule } from "@agm/core";
import { TextMaskModule } from "angular2-text-mask";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { InicioComponent } from "./inicio/inicio.component";
import { EmpresaComponent } from "./empresa/empresa.component";
import { AuxiliarEmpresaComponent } from "./empresa/auxiliar/auxiliar-empresa.component";
import { AlterarsenhaComponent } from "./empresa/alterarsenha/alterarsenha.component";
import { RegistrarContatoComponent } from "./empresa/registrar-contato/registrar-contato.component";
import { ModalRegistrarContatoComponent } from "./empresa/modal-registrar-contato/modal-registrar-contato.component";
import { ModalInformacaoEmpresaComponent } from "./empresa/modal-informacao-empresa/modal-informacao-empresa.component";
import { UsuariosComponent } from "./usuarios/usuarios.component";
import { AlterarsenhaComponent as SenhaUsuario } from "./usuarios/auxiliar/alterarsenha/alterarsenha.component";
import { UsuariosAuxiliarComponent } from "./usuarios/auxiliar/auxiliar-usuarios.component";
import { NotificacaoComponent } from "./notificacao/notificacao.component";
import { ProdutosComponent } from "./produtos/produtos.component";
import { FormProdutosComponent } from "./produtos/form-produtos/form-produtos.component";
import { PontuacaoComponent } from "./pontuacao/pontuacao.component";
import { CartaoComponent } from "./pontuacao/components/cartao/cartao.component";
import { SafePipeModule } from "safe-pipe";
import { ConfiguracaoCartaoComponent } from "./configuracao-cartao/configuracao-cartao.component";
import { ModalConfiguracaoCartaoComponent } from "./configuracao-cartao/modal-configuracao-cartao/modal-configuracao-cartao.component";
import { MembergetmemberComponent } from "./membergetmember/membergetmember.component";
import { ControleDeAcessoComponent } from "./controle-de-acesso/controle-de-acesso.component";
import { ModalControleDeAcessoComponent } from "./controle-de-acesso/modal-controle-de-acesso/modal-controle-de-acesso.component";
import { ModalVisualizacaoPermissaoComponent } from "./controle-de-acesso/modal-visualizacao-permissao/modal-visualizacao-permissao.component";
import { AuxiliarNotificacaoComponent } from "./notificacao/auxiliar/auxiliar-notificacao.component";
import { ClientesComponent } from "./clientes/clientes.component";
import { InformacaoClienteComponent } from "./clientes/informacao-cliente/informacao-cliente.component";
import { ModalEmojiComponent } from "./notificacao/modal-emoji/modal-emoji.component";
import { DocApiComponent } from "./doc-api/doc-api.component";
import { AcessoApiComponent } from "./acesso-api/acesso-api.component";
import { NotificacaoDetalheComponent } from "./notificacao/notificacao-detalhe/notificacao-detalhe.component";
import { InformacaoPlanoComponent } from "./informacao-plano/informacao-plano.component";
import { RelatorioClienteRecorrenteComponent } from "./relatorio-cliente-recorrente/relatorio-cliente-recorrente.component";
import { RelatorioClienteNaoRecorrenteComponent } from "./relatorio-cliente-nao-recorrente/relatorio-cliente-nao-recorrente.component";
import { RelatorioFaturamentoCartaoFidelidadeComponent } from "./relatorio-faturamento-cartao-fidelidade/relatorio-faturamento-cartao-fidelidade.component";
import { RelatorioFaturamentoCartaoFidelidadeDetalhesComponent } from "./relatorio-faturamento-cartao-fidelidade/relatorio-faturamento-cartao-fidelidade-detalhes/relatorio-faturamento-cartao-fidelidade-detalhes.component";
import { RelatorioPontuacaoFuncionarioComponent } from "./relatorio-pontuacao-funcionario/relatorio-pontuacao-funcionario.component";
import { FormConfiguracaoCartaoComponent } from "./configuracao-cartao/form-configuracao-cartao/form-configuracao-cartao.component";
import { MaskDateDirective } from "../../shared/pipe/date.pipe";
import { ModalImportaClienteComponent } from "./importa-cliente/modal-importa-cliente/modal-importa-cliente.component";
import { ImportaClienteComponent } from "./importa-cliente/importa-cliente.component";
import { VisualizarImportacaoClienteComponent } from "./importa-cliente/visualizar-importacao-cliente/visualizar-importacao-cliente.component";
import { ModalEditarClienteImportacaoComponent } from "./importa-cliente/modal-editar-cliente-importacao/modal-editar-cliente-importacao.component";
import { ModalEditarClienteComponent } from "./clientes/modal-editar-cliente/modal-editar-cliente.component";
import { MeuNegocioComponent } from "./meu-negocio/meu-negocio.component";
import { PerfilComponent } from "./meu-negocio/perfil/perfil.component";
import { RedesSociaisComponent } from "./meu-negocio/perfil/redes-sociais/redes-sociais.component";
import { ModalFormRedeSocialComponent } from "./meu-negocio/perfil/redes-sociais/modal-form-rede-social/modal-form-rede-social.component";
import { EnderecoComponent } from "./meu-negocio/perfil/endereco/endereco.component";
import { MeioDeContatoComponent } from "./meu-negocio/perfil/meio-de-contato/meio-de-contato.component";
import { ComodidadesComponent } from "./meu-negocio/perfil/comodidades/comodidades.component";
import { HorarioFuncionamentoComponent } from "./meu-negocio/perfil/horario-funcionamento/horario-funcionamento.component";
import { LojaComponent } from "./meu-negocio/perfil/loja/loja.component";
import { environment } from "../../../environments/environment";
import { ModalFormMeioDeContatoComponent } from "./meu-negocio/perfil/meio-de-contato/modal-form-meio-de-contato/modal-form-meio-de-contato.component";
import { ModalFormComodidadeComponent } from "./meu-negocio/perfil/comodidades/modal-form-comodidade/modal-form-comodidade.component";
import { ModalFormHorarioFuncionamentoComponent } from "./meu-negocio/perfil/horario-funcionamento/modal-form-horario-funcionamento/modal-form-horario-funcionamento.component";
import { ImageCropperModule } from "ngx-image-cropper";
import { NgxMapboxGLModule } from "ngx-mapbox-gl";
import { MultiplasLojasComponent } from "./multiplas-lojas/multiplas-lojas.component";
import { FormEmpresaComponent } from "./multiplas-lojas/form/form-empresa.component";
import { CadastroEmpresaComponent } from "./multiplas-lojas/form/cadastro/cadastro-empresa.component";
import { LogoEmpresaComponent } from "./multiplas-lojas/form/logo/logo-empresa.component";
import { PontuacaoLoteComponent } from "./pontuacao-lote/pontuacao-lote.component";
import { ModalPontuacaoLoteComponent } from "./pontuacao-lote/modal-pontuacao-lote/modal-pontuacao-lote.component";
import { VisualizarPontuacaoLoteComponent } from "./pontuacao-lote/visualizar-pontuacao-lote/visualizar-pontuacao-lote.component";

const routes: Routes = [
  { path: "inicio", component: InicioComponent },
  { path: "dashboard", component: DashboardComponent },
  { path: "notificacao", component: NotificacaoComponent },
  { path: "notificacao/novo", component: AuxiliarNotificacaoComponent },
  { path: "notificacao/detalhe/:id", component: NotificacaoDetalheComponent },
  { path: "produtos", component: ProdutosComponent },
  { path: "pontuacao", component: PontuacaoComponent },
  { path: "configuracaocartao", component: ConfiguracaoCartaoComponent },
  {
    path: "configuracaocartao/novo",
    component: FormConfiguracaoCartaoComponent,
  },
  { path: "controledeacesso", component: ControleDeAcessoComponent },
  { path: "cliente", component: ClientesComponent },
  { path: "importar-cliente", component: ImportaClienteComponent },
  {
    path: "importar-cliente/detalhe/:id",
    component: VisualizarImportacaoClienteComponent,
  },

  { path: "cliente/informacoes", component: InformacaoClienteComponent },
  { path: "acesso-api", component: AcessoApiComponent },
  { path: "informacao-plano", component: InformacaoPlanoComponent },
  {
    path: "relatorio-recorrencia",
    component: RelatorioClienteRecorrenteComponent,
  },
  {
    path: "relatorio-nao-recorrencia",
    component: RelatorioClienteNaoRecorrenteComponent,
  },
  {
    path: "relatorio-faturamento-cartao-fidelidade",
    component: RelatorioFaturamentoCartaoFidelidadeComponent,
  },
  {
    path: "relatorio-faturamento-cartao-fidelidade/detalhe",
    component: RelatorioFaturamentoCartaoFidelidadeDetalhesComponent,
  },
  {
    path: "relatorio-pontuacao-funcionario",
    component: RelatorioPontuacaoFuncionarioComponent,
  },

  { path: "meu-negocio", component: MeuNegocioComponent },
  { path: "meu-negocio/perfil", component: PerfilComponent },

  { path: "gerir-lojas", component: MultiplasLojasComponent },
  { path: "gerir-lojas/nova-empresa", component: FormEmpresaComponent },
  { path: "gerir-lojas/detalhe/:id", component: FormEmpresaComponent },

  { path: "pontuacao-lote", component: PontuacaoLoteComponent },
  { path: "pontuacao-lote/detalhe/:id", component: VisualizarPontuacaoLoteComponent },
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    NgxSelectModule,
    Ng2TableModule,
    NgxDatatableModule,
    NgxCurrencyModule,
    TextMaskModule,
    ChartsModule,
    NgxMaskModule,
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    SafePipeModule,
    PickerModule,

    AgmCoreModule.forRoot({
      apiKey: "2VSHIjwp3s9qJMh-346q41IzT1k=",
    }),
    NgxMapboxGLModule.forRoot({
      accessToken:
        "pk.eyJ1Ijoid3lra3NzIiwiYSI6ImNqMjR6aTdmdzAwNHMzMnBvbjBucjlqNm8ifQ.6GjGpofWBVaIuSnhdXQb5w",
    }),
    ImageCropperModule,
  ],
  declarations: [
    DashboardComponent,
    InicioComponent,
    EmpresaComponent,
    AuxiliarEmpresaComponent,
    AlterarsenhaComponent,
    RegistrarContatoComponent,
    ModalRegistrarContatoComponent,
    ModalInformacaoEmpresaComponent,
    UsuariosComponent,
    SenhaUsuario,
    UsuariosAuxiliarComponent,
    NotificacaoComponent,
    ProdutosComponent,
    FormProdutosComponent,
    PontuacaoComponent,
    CartaoComponent,
    ConfiguracaoCartaoComponent,
    ModalConfiguracaoCartaoComponent,
    MembergetmemberComponent,
    ControleDeAcessoComponent,
    ModalControleDeAcessoComponent,
    ModalVisualizacaoPermissaoComponent,
    AuxiliarNotificacaoComponent,
    ClientesComponent,
    InformacaoClienteComponent,
    ModalEmojiComponent,
    AcessoApiComponent,
    NotificacaoDetalheComponent,
    InformacaoPlanoComponent,
    RelatorioClienteRecorrenteComponent,
    RelatorioClienteNaoRecorrenteComponent,
    RelatorioFaturamentoCartaoFidelidadeComponent,
    RelatorioFaturamentoCartaoFidelidadeDetalhesComponent,
    RelatorioPontuacaoFuncionarioComponent,
    FormConfiguracaoCartaoComponent,
    MaskDateDirective,
    ModalImportaClienteComponent,
    ImportaClienteComponent,
    VisualizarImportacaoClienteComponent,
    ModalEditarClienteImportacaoComponent,
    ModalEditarClienteComponent,
    MeuNegocioComponent,
    PerfilComponent,
    RedesSociaisComponent,
    ModalFormRedeSocialComponent,
    EnderecoComponent,
    MeioDeContatoComponent,
    ComodidadesComponent,
    HorarioFuncionamentoComponent,
    LojaComponent,
    ModalFormMeioDeContatoComponent,
    ModalFormComodidadeComponent,
    ModalFormHorarioFuncionamentoComponent,
    MultiplasLojasComponent,
    FormEmpresaComponent,
    CadastroEmpresaComponent,
    LogoEmpresaComponent,
    PontuacaoLoteComponent,
    ModalPontuacaoLoteComponent,
    VisualizarPontuacaoLoteComponent
  ],
  exports: [
    RouterModule,
    NgxSelectModule,
    BsDatepickerModule,
    DatepickerModule,
    MaskDateDirective,
  ],
  entryComponents: [
    ModalImportaClienteComponent,
    ModalRegistrarContatoComponent,
    ModalInformacaoEmpresaComponent,
    FormProdutosComponent,
    ModalConfiguracaoCartaoComponent,
    ModalControleDeAcessoComponent,
    ModalVisualizacaoPermissaoComponent,
    ModalEmojiComponent,
    ModalEditarClienteImportacaoComponent,
    ModalEditarClienteComponent,
    ModalFormRedeSocialComponent,
    ModalFormMeioDeContatoComponent,
    ModalFormComodidadeComponent,
    ModalFormHorarioFuncionamentoComponent,
    ModalPontuacaoLoteComponent,
  ],
})
export class FidelModule {}
